// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Gambia */
const GM = /^(?:556\d{4}|(?:[23679]\d|4[015]|5[0-489]|8[4-7])\d{5})$/;

export default GM;
